import React, {useEffect, useState} from "react";
import {
    getBusinessById,
    getEmployeeByBusiness,
    getPendingPayoutsByBusinessID,
} from "../../services/firestoreService";
import BusinessLayout from "../../components/BusinessLayout";
import {useParams} from "react-router-dom";
import {useAuth} from "../../context/AuthProvider";

export default function BusinessPendingPayouts() {
    const {userData} = useAuth();
    const [business, setBusiness] = useState(null);
    const [employees, setEmployees] = useState([]);
    const [completedPayouts, setCompletedPayouts] = useState([]);


    useEffect(() => {
        const fetchData = async () => {
            const [businessData, employeeData] = await Promise.all([
                getBusinessById(userData.businessID),
                getEmployeeByBusiness(userData.businessID),
            ]);

            const completed = await getPendingPayoutsByBusinessID(userData.businessID);

            setCompletedPayouts(completed);


            setBusiness(businessData);
            setEmployees(employeeData);
        };

        fetchData();
    }, [userData]);

    const getEmployeeName = (id) => {
        const emp = employees.find((e) => e.id === id);
        return emp?.displayName || "Unknown";
    };

    return (
        <BusinessLayout>
            <div className="min-h-screen bg-white w-full max-w-6xl mx-auto py-8">
                <h1 className="text-2xl font-bold mb-6">{business?.name} Pending Payouts</h1>

                {completedPayouts.length === 0 ? (
                    <p className="text-sm text-gray-500 p-4">No payouts found.</p>
                ) : (
                    completedPayouts.map((payout) => (
                        <div
                            key={payout.id}
                            className="bg-gray-100 border border-gray-200 rounded-lg shadow-md p-4 mb-6"
                        >
                            <div className="flex justify-between items-center mb-2">
                                <div>
                                    <p className="text-lg font-semibold">
                                        {getEmployeeName(payout.employeeID)} (ID: {payout.employeeID})
                                    </p>
                                    <p className="text-sm text-gray-600">
                                        Business ID: {payout.businessID}
                                    </p>
                                </div>
                                <div className="text-right">
                                    <p className="text-xl font-bold text-green-700">
                                        €{payout.totalAmount.toFixed(2)}
                                    </p>
                                    <p
                                        className={`text-sm font-medium ${
                                            payout.status === "paid"
                                                ? "text-green-600"
                                                : "text-yellow-600"
                                        }`}
                                    >
                                        Status: PENDING
                                    </p>
                                </div>
                            </div>

                            {/* Tips inside payout */}
                            <div className="mt-2 text-sm text-gray-700">
                                <p className="font-medium mb-1">Included Tips:</p>
                                <div className="space-y-1">
                                    {payout.tips?.length > 0 ? (
                                        payout.tips.map((tip) => (
                                            <div key={tip.id} className="text-sm">
                                                • €{tip.amount.toFixed(2)} –{" "}
                                                {new Date(tip.createdAt.seconds * 1000).toLocaleString()}
                                            </div>
                                        ))
                                    ) : (
                                        <p className="text-gray-500 italic">No tip breakdown available</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </BusinessLayout>
    );
}
